/** @format */

import React from 'react';
import { inject, observer } from 'mobx-react';
import { Table, Button, Form, Icon } from 'semantic-ui-react';
import { getAttributeFromObject } from '../../helpers/objectHelpers';
import AdminPage from '../shared/AdminPage/AdminPage';
import AdminPageModal from '../shared/AdminPage/AdminPageModal/AdminPageModal';
import CarInput from './CarInput';
import './AdminCars.css';

@inject('CarsStore')
@observer
class AdminCars extends AdminPage {
  getStore() {
    const { CarsStore } = this.props;
    return CarsStore;
  }

  renderTableModal = () => {
    const store = this.getStore();
    const models = [
      { value: 'Nessuno', id: null },
      ...store.getMakerModels(store.edit.currentItem.makerUid),
    ];
    const versions = [
      { value: 'Nessuno', id: null },
      ...store.getModelVersions(store.edit.currentItem.modelUid),
    ];

    const modelOptions = models.map(model => ({
      text: model.value,
      key: model.id,
      value: model.id,
    }));

    const versionOptions = versions.map(version => ({
      text: version.value,
      key: version.id,
      value: version.id,
    }));

    const modelsDisabled = {
      select:
        !store.edit.currentItem.makerUid ||
        (!store.edit.currentItem.makerUid && store.edit.currentItem.maker),
      text: !store.edit.currentItem.makerUid && !store.edit.currentItem.maker,
    };

    const versionsDisabled = {
      select:
        !store.edit.currentItem.modelUid ||
        (!store.edit.currentItem.modelUid && store.edit.currentItem.model),
      text: !store.edit.currentItem.modelUid && !store.edit.currentItem.model,
    };

    return (
      <AdminPageModal
        title={
          store.edit.currentItem.maker
            ? `Modifica ${store.edit.currentItem.maker}`
            : 'Aggiungi costruttore'
        }
        open={store.edit.modal}
        errors={store.edit.errors}
        toggleEditModal={
          store.edit.newModal ? store.toggleNewModal : store.toggleEditModal
        }
        currentItem={store.edit.currentItem}
        onSubmit={store.submit}
        onDelete={store.deleteItem}
        isEdit={store.edit.editModal}
      >
        {store.edit.editModal && (
          <Form.Input
            label={
              store.edit.currentItem.makerUid
                ? 'Modifica costruttore'
                : 'Nuovo costruttore'
            }
            name="maker"
            value={store.edit.currentItem.maker}
            onChange={(e, input) =>
              store.handleInputChange(input.value, 'maker')
            }
          />
        )}
        {(store.edit.currentItem.maker || store.edit.currentItem.makerUid) && (
          <CarInput
            createLabel="Nuovo modello"
            editLabel="Modifica modello"
            buttonLabel="Gestisci modelli"
            chooseLabel="Scegli un modello da modificare"
            name="modelUid"
            value={store.edit.currentItem.modelUid}
            onChange={(e, input) =>
              store.handleInputChange(input.value, 'modelUid')
            }
            options={modelOptions}
            textName="model"
            textValue={store.edit.currentItem.model}
            textOnChange={(e, input) =>
              store.handleInputChange(input.value, 'model')
            }
            textDisabled={modelsDisabled.text}
            isNew={store.edit.newModal || !store.edit.currentItem.makerUid}
            forceSelect={
              store.edit.newVersionEnabled && !store.edit.currentItem.model
            }
            active={store.edit.newModelEnabled}
            onButtonClick={e => {
              e.preventDefault();
              store.toggleModel();
            }}
          />
        )}
        {store.edit.newModelEnabled && (
          <CarInput
            createLabel="Nuova versione"
            editLabel="Modifica versione"
            buttonLabel="Gestisci versioni"
            chooseLabel="Scegli una versione da modificare"
            name="versionUid"
            value={store.edit.currentItem.versionUid}
            onChange={(e, input) =>
              store.handleInputChange(input.value, 'versionUid')
            }
            options={versionOptions}
            textName="maker"
            textValue={store.edit.currentItem.version}
            textOnChange={(e, input) =>
              store.handleInputChange(input.value, 'version')
            }
            textDisabled={versionsDisabled.text}
            isNew={store.edit.newModal || !store.edit.currentItem.makerUid}
            active={store.edit.newVersionEnabled}
            onButtonClick={e => {
              e.preventDefault();
              store.toggleVersion();
            }}
          />
        )}
      </AdminPageModal>
    );
  };

  renderTableBody = () => {
    const store = this.getStore();
    const items = store.searchedItems;
    const tableKeys = store.tableKeys;

    return items.map((item, index) => {
      return (
        <Table.Row key={index}>
          {tableKeys.map((key, index) => {
            return (
              <Table.Cell key={key.prop + '_' + index}>
                {getAttributeFromObject(key.prop, item)}
                <div className="table-actions">
                  <Button>
                    <Icon
                      name="pencil"
                      className="edit"
                      onClick={() => {
                        store.toggleEditModal();
                        store.loadCurrentItem(item.uid);
                      }}
                    />
                  </Button>
                  <Button>
                    <Icon
                      name="plus"
                      className="add"
                      onClick={() => {
                        store.toggleNewModal();
                        store.loadCurrentItem(item.uid);
                      }}
                    />
                  </Button>
                </div>
              </Table.Cell>
            );
          })}
        </Table.Row>
      );
    });
  };
}

export default AdminCars;
